import { Reducer } from "redux";
import { CostCenterResponse } from "../../models/cost-center/cost-center-response.model";
import { DepartmentResponse } from "../../models/department/department-response.model";
import { UnitResponse } from "../../models/unit/unit-response.model";
import { COST_CENTER_LIST, COST_CENTER_LIST_ERROR, COST_CENTER_LIST_SUCCESS, UNIT_LIST, UNIT_LIST_SUCCESS, UNIT_LIST_ERROR, DEPARTMENT_LIST, DEPARTMENT_LIST_SUCCESS, DEPARTMENT_LIST_ERROR } from "../contants";

type AssignorInitStateType = {
    costCenters: any | CostCenterResponse[];
    units: any | UnitResponse[];
    departments: any | DepartmentResponse[];
    loading: boolean;
    error: boolean;
    errorMessage: string;
}

const INIT_STATE = {
    costCenters: [],
    units: [],
    departments: [],
    loading: false,
    error: false,
    errorMessage: '',
};

const AssignorReducer: Reducer<AssignorInitStateType> = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case COST_CENTER_LIST:
        return { ...state, loading: true, error: false };
    case COST_CENTER_LIST_SUCCESS:
        return {
            ...state,
            loading: false,
            costCenters: action.payload,
            error: false,
        };
    case COST_CENTER_LIST_ERROR:
        return {
            ...state,
            loading: false,
            costCenters: [],
            error: true,
            errorMessage: action.payload.message,
        };
    case UNIT_LIST:
        return { ...state, loading: true, error: false };
    case UNIT_LIST_SUCCESS:
        return {
            ...state,
            loading: false,
            units: action.payload,
            error: false,
        };
    case UNIT_LIST_ERROR:
        return {
            ...state,
            loading: false,
            units: [],
            error: true,
            errorMessage: action.payload.message,
        };
    case DEPARTMENT_LIST:
        return { ...state, loading: true, error: false };
    case DEPARTMENT_LIST_SUCCESS:
        return {
            ...state,
            loading: false,
            departments: action.payload,
            error: false,
        };
    case DEPARTMENT_LIST_ERROR:
        return {
            ...state,
            loading: false,
            departments: [],
            error: true,
            errorMessage: action.payload.message,
        };
    default:
        return { ...state };
  }
};

export default AssignorReducer;